// to check if a password satisfies the criteria, Caller :
//  const password = "Abcdefg1@";
// const result = isPasswordValid(password);
// if (result.valid) {
// } else {
//   result.errors.forEach((error) => {
//   });
// }

import mada from "../assets/images/mada.svg";
import visa from "../assets/images/visa.svg";
import master from "../assets/images/mastercard.svg";
import amex from "../assets/images/amex_rounded.svg";
import apple from "../assets/images/Apple Pay Icon.svg";
import maestro from "../assets/images/maestro.svg";
import Discover from "../assets/images/discover.svg";
import PayPak from "../assets/images/paypak.png";
import GCCNET from "../assets/images/GCCNET.svg";
import { lang } from "../models";

const isPasswordValid = (password: string) => {
  const errors = [];

  // Check if password length is at least 8 characters
  if (password.length < 8) {
    errors.push("Password must contain at least 8 characters");
  }

  // Check if password contains at least one uppercase letter
  if (!/[A-Z]/.test(password)) {
    errors.push("Password must contain at least one uppercase letter");
  }

  // Check if password contains at least one lowercase letter
  if (!/[a-z]/.test(password)) {
    errors.push("Password must contain at least one lowercase letter");
  }

  // Check if password contains at least one number
  if (!/[0-9]/.test(password)) {
    errors.push("Password must contain at least one number");
  }

  // Check if password contains at least one special character
  if (!/[@#$&%]/.test(password)) {
    errors.push(
      "Password must contain at least one special character (@, #, $, &, %)"
    );
  }

  // Check if password contains three identical numbers in a row
  for (let i = 0; i < password.length - 2; i++) {
    if (
      password[i] === password[i + 1] &&
      password[i + 1] === password[i + 2] &&
      /[0-9]/.test(password[i])
    ) {
      errors.push("Password cannot contain three identical numbers in a row");
      break;
    }
  }

  // Return the validation result and the error messages
  return { valid: errors.length === 0, errors };
};

function capitalizeFirstLetter(str: string) {
  return str?.charAt(0).toUpperCase() + str?.slice(1).toLowerCase();
}
function addSpacesToCamelCase(str: string) {
  const stringWithSpaces = str.replace(/([a-z])([A-Z])/g, "$1 $2");
  return stringWithSpaces.split(" ").map(capitalizeFirstLetter).join(" ");
}

const getImageForPaymentMethod = (type: string) => {
  switch (type) {
    case "mada":
    case "Mada":
    case "MADA":
    case "P1":
      return mada;
    case "visa":
    case "VC":
    case "VISA":
      return visa;
    case "mastercard":
    case "MasterCard":
    case "MASTERCARD":
    case "MC":
      return master;
    case "amex":
    case "AMEX":
    case "AX":
      return amex;
    case "DC":
    case "Discover":
    case "DISCOVER":
      return Discover;
    case "PP":
    case "PayPak":
    case "PAYPAK":
      return PayPak;
    case "DM":
    case "Maestro":
    case "MAESTRO":
      return maestro;
    case "GN":
      return GCCNET;
    case "applepay":
      return apple;
    default:
      return "";
  }
};

function trimString(inputString: any) {
  const firstPart = inputString?.slice(0, 10);
  const lastPart = inputString?.slice(-10);
  return `${firstPart}...${lastPart}`;
}

const originalString =
  "This is a long example string with more than 20 characters.";
const trimmedString = trimString(originalString);

function isValidDateFormat(dateString: any) {
  const dateFormatRegex = /^(0[1-9]|1[0-2])\/\d{4}$/;

  if (dateFormatRegex.test(dateString)) {
    return true;
  } else {
    return false;
  }
}

function formatDate(timestamp: string): string {
  // Check if the timestamp is in milliseconds or seconds
  //const isMilliseconds = timestamp?.length === 13;
  // const timeInMilliseconds = isMilliseconds ? parseInt(timestamp) : parseInt(timestamp) * 1000;

  // Create a new Date object using the timestamp
  //const date = new Date(timeInMilliseconds);
  const date = new Date(timestamp);
  // Define options for formatting the date
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    timeZone: "UTC", // Adjust time zone as needed
  };
  return date.toLocaleString("en-US", options);
}

function separateDateAndTime(dateTimeStr: any) {
  if (!dateTimeStr || typeof dateTimeStr !== "string") {
    return;
  }

  const [datePart, fullTimePart] = dateTimeStr.split("T");

  if (!datePart || !fullTimePart) {
    return;
  }

  // Extract hours and minutes from the time part
  const [hours, minutes] = fullTimePart.split(":").slice(0, 2);

  return {
    date: datePart,
    time: `${hours}:${minutes}`,
  };
}

function formatDateAndTime(isoString: string) {
  const date = new Date(isoString);

  if (isNaN(date.getTime())) {
    return "Invalid Date";
  }

  const optionsDate: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "short",
    day: "numeric",
  };

  const optionsTime: Intl.DateTimeFormatOptions = {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  };

  const formattedDate = date.toLocaleString("en-US", optionsDate);
  const formattedTime = date.toLocaleString("en-US", optionsTime);

  // Remove extra zeroes from milliseconds
  const milliseconds = date
    .getUTCMilliseconds()
    .toString()
    .padStart(3, "0")
    .slice(0, 3);

  return {
    date: formattedDate,
    time: formattedTime,
    milliseconds: milliseconds,
  };
}

const languageChoose = () => {
  const changeLanguage = (lang: any) => {
    return () => {
      localStorage.setItem("lang", lang);
      window.location.reload();
    };
  };

  if (lang === "en") {
    return (
      <button className="lang" onClick={changeLanguage("fr")}>
        <span>
          <svg
            fill="#000000"
            width="64px"
            height="64px"
            viewBox="-1 0 19 19"
            xmlns="http://www.w3.org/2000/svg"
            className="cf-icon-svg"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              <path d="M16.417 9.57a7.917 7.917 0 1 1-8.144-7.908 1.758 1.758 0 0 1 .451 0 7.913 7.913 0 0 1 7.693 7.907zM5.85 15.838q.254.107.515.193a11.772 11.772 0 0 1-1.572-5.92h-3.08a6.816 6.816 0 0 0 4.137 5.727zM2.226 6.922a6.727 6.727 0 0 0-.511 2.082h3.078a11.83 11.83 0 0 1 1.55-5.89q-.249.083-.493.186a6.834 6.834 0 0 0-3.624 3.622zm8.87 2.082a14.405 14.405 0 0 0-.261-2.31 9.847 9.847 0 0 0-.713-2.26c-.447-.952-1.009-1.573-1.497-1.667a8.468 8.468 0 0 0-.253 0c-.488.094-1.05.715-1.497 1.668a9.847 9.847 0 0 0-.712 2.26 14.404 14.404 0 0 0-.261 2.309zm-.974 5.676a9.844 9.844 0 0 0 .713-2.26 14.413 14.413 0 0 0 .26-2.309H5.903a14.412 14.412 0 0 0 .261 2.31 9.844 9.844 0 0 0 .712 2.259c.487 1.036 1.109 1.68 1.624 1.68s1.137-.644 1.623-1.68zm4.652-2.462a6.737 6.737 0 0 0 .513-2.107h-3.082a11.77 11.77 0 0 1-1.572 5.922q.261-.086.517-.194a6.834 6.834 0 0 0 3.624-3.621zM11.15 3.3a6.82 6.82 0 0 0-.496-.187 11.828 11.828 0 0 1 1.55 5.89h3.081A6.815 6.815 0 0 0 11.15 3.3z"></path>
            </g>
          </svg>
          {/*             <svg viewBox="0 0 36 36" aria-hidden="true" role="img" className="iconify iconify--twemoji" preserveAspectRatio="xMidYMid meet" fill="#000000"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill="#006C35" d="M32 5H4a4 4 0 0 0-4 4v18a4 4 0 0 0 4 4h28a4 4 0 0 0 4-4V9a4 4 0 0 0-4-4z"> </path> <g fill="#FFF"> <path d="M8.919 14.05c.632.06.283-1.069.512-1.274c.043-.101.123-.102.129.026v.958c-.006.312.199.403.358.468c.166-.013.276-.007.341.154l.078 1.658s.384.11.402-.933c.019-.612-.122-1.124-.039-1.243c.003-.117.152-.124.256-.067c.165.116.239.26.495.203c.391-.107.625-.297.631-.597c-.023-.285-.055-.57-.178-.855c.017-.052-.075-.186-.058-.238c.07.11.177.101.201 0c-.066-.219-.169-.429-.337-.52c-.138-.122-.34-.097-.414.157c-.034.292.106.64.318.923c.045.111.109.295.081.461c-.113.064-.227.038-.321-.062c0 0-.311-.233-.311-.285c.083-.528.019-.588-.027-.734c-.032-.202-.128-.267-.206-.405c-.078-.082-.183-.082-.233 0c-.138.238-.074.75.026.979c.071.21.181.343.129.343c-.043.119-.131.091-.195-.046c-.092-.284-.11-.707-.11-.898c-.028-.236-.058-.741-.213-.869c-.095-.129-.236-.067-.285.052c-.01.234-.012.469.015.686c.106.379.14.713.192 1.102c.014.521-.301.226-.287-.032c.073-.335.054-.863-.011-.997c-.051-.133-.112-.167-.236-.145c-.098-.008-.352.27-.424.73c0 0-.061.237-.087.448c-.035.238-.191.406-.301-.033c-.095-.319-.153-1.106-.312-.922c-.046.615-.101 1.697.421 1.807z"> </path> <path d="M9.87 14.499c-.52.01-1.281.683-1.302 1.056c.548-.264 1.087-.518 1.645-.79c-.09-.135-.005-.256-.343-.266z"> </path> <path d="M12.737 16.516c.241-.803-.039-1.395.092-1.392c.277.299.665.04.75-.064c.037-.052.128-.086.192-.018c.217.156.599.082.678-.192a6.03 6.03 0 0 0 .092-.833c-.177.055-.309.092-.321.165l-.037.238c-.015.077-.168.08-.174-.018c-.067-.305-.345-.345-.513.128c-.113.092-.317.11-.339-.027c.027-.317-.101-.36-.357-.211c-.082-.629-.165-1.23-.247-1.859c.107-.003.205.076.302-.046c-.107-.333-.333-1.013-.458-1.062c-.061-.074-.113-.028-.192-.009c-.134.043-.259.159-.22.384c.159.965.263 1.7.421 2.665c.024.113-.07.262-.192.247c-.207-.14-.259-.424-.613-.412c-.257.003-.55.281-.586.55c-.043.213-.058.445 0 .632c.18.216.397.195.586.146c.155-.064.284-.22.338-.183c.037.045.009.558-.732.952c-.449.201-.806.247-.998-.119c-.119-.229.009-1.099-.284-.897c-.867 2.235 2.03 2.545 2.354.092c.031-.101.153-.202.174-.037c-.067 2.222-2.241 2.375-2.61 1.676c-.092-.165-.119-.531-.128-.751c-.055-.437-.284-.269-.32.164c-.037.241-.027.309-.027.54c.115 1.755 2.915 1.001 3.369-.449zm-1.08-1.518c-.018.034-.097.02-.155.02c-.066-.003-.097-.014-.137-.067c-.018-.06.038-.117.063-.162c.031-.053.198-.108.257.04a.168.168 0 0 1-.028.169z"> </path> <path d="M13.602 13.009c.174-.064.999-1.007.999-1.007c-.043-.037-.081-.064-.124-.101c-.046-.04-.041-.08 0-.119c.204-.119.139-.38.032-.499a.495.495 0 0 0-.444.004c-.143.137-.177.357-.064.495c.11.052.22.163.147.224c-.337.36-1.261.981-1.154 1.003c.023.03.59.029.608 0zm.611-1.481c.053-.013.121.034.153.104c.032.07.015.137-.037.15h-.002c-.052.013-.12-.034-.152-.104c-.031-.071-.014-.137.038-.15zm-5.351 5.73c-.136.277-.193.087-.205-.068a3.553 3.553 0 0 1 .039-.779c.034-.22 0-.153-.07-.064c-.309.492-.336 1.228-.165 1.447c.09.104.239.15.35.116c.194-.084.279-.478.233-.621c-.066-.101-.117-.117-.182-.031zm10.181-5.208c.356.478.694.965 1.025 1.461c.065.43.112.85.14 1.267c.055.804.071 1.674.021 2.521c.15.006.393-.244.477-.609c.055-.505-.02-1.404-.025-1.702a22.071 22.071 0 0 0-.027-.56c.394.644.778 1.318 1.153 2.067c.137-.064.107-.83.027-.938c-.3-.643-.713-1.279-.845-1.523c-.049-.09-.216-.346-.415-.639a7.506 7.506 0 0 0-.084-.698c-.062-.428.177.047.144-.202c-.077-.428-.315-.717-.593-1.109c-.09-.127-.087-.153-.226.031a.772.772 0 0 0-.066.351a2.458 2.458 0 0 0-.139-.185a51.319 51.319 0 0 0-.455-.388c-.101-.072-.347-.202-.391.014a1.25 1.25 0 0 0 .022.454c.026.107.181.285.257.387zm.74-.024c.019.083.039.166.052.251l.015.081a3.628 3.628 0 0 0-.131-.172c-.164-.194-.028-.152.064-.16z"> </path> <path d="M21.919 16.693c-.348.363-.85.81-1.396 1.017c-.059.066.146.349.41.349c.443-.052.833-.301 1.194-.956c.097-.152.267-.479.271-.733c.033-1.486-.074-2.643-.297-3.717a.6.6 0 0 1 .012-.259c.028-.034.126 0 .178-.084c.075-.078-.201-.718-.359-.964c-.056-.11-.075-.184-.168.013c-.098.16-.163.439-.155.699c.211 1.463.276 2.744.414 4.207c.011.141-.01.347-.104.428zm5.83-3.71c-.015-.104-.061-.346-.043-.377c.028-.074.173.008.225-.077c.076-.077-.374-.655-.531-.901c-.057-.11-.076-.184-.169.013c-.098.16-.132.447-.093.699c.235 1.589.41 2.783.446 4.192c-.021.134-.025.206-.088.374c-.139.178-.292.4-.437.508c-.144.107-.451.21-.552.289c-.317.185-.318.396-.06.403c.442-.052.966-.088 1.327-.634c.097-.152.212-.565.217-.819c.033-1.486-.019-2.596-.242-3.67zm-3.351 1.237c.004-.204.023-.474.034-.643c.005-.063.02-.134.08-.15c.061-.016.169.062.17-.004c-.012-.129-.038-.321-.111-.412c-.1-.148-.365-.112-.412.12c.001.086.04.132.033.21c-.012.044-.058.074-.167.022c.018-.016-.071-.139-.071-.139c-.085-.052-.199.003-.272.05a.415.415 0 0 0-.024.33c.12.227.539.612.74.616z"> </path> <path d="M24.257 12.481c.293.359.592.723.893 1.093c.065.826.082 1.502.146 2.328c-.009.35-.117.655-.22.699c0 0-.155.09-.259-.009c-.076-.031-.379-.505-.379-.505c-.155-.142-.257-.102-.367 0c-.304.293-.441.843-.647 1.221c-.054.085-.204.157-.371-.006c-.423-.579-.175-1.402-.227-1.19c-.377.425-.211 1.128-.126 1.28c.124.248.225.408.467.531c.22.162.392.06.486-.053c.222-.231.225-.816.329-.934c.072-.213.257-.177.346-.082a.876.876 0 0 0 .315.273c.207.183.454.216.697.049c.166-.093.275-.214.372-.453c.108-.288.049-1.612.027-2.406c.155.2.306.409.459.618c.067.663.105 1.323.083 1.997c-.016.135.47-.4.466-.654c-.002-.205 0-.391 0-.566c.234.352.462.715.676 1.099c.134-.07.09-.825.005-.929c-.247-.414-.576-.845-.803-1.153c-.015-.039-.023-.083-.041-.12c-.091-.211-.034-.381-.077-.605c-.042-.225-.031-.561-.096-.828c-.018-.104-.072-.438-.056-.469c.026-.075.126.002.175-.084c.073-.08-.253-.925-.419-1.167c-.06-.108-.168-.071-.302.105c-.123.116-.077.38-.03.631c.117.608.215 1.191.299 1.768a57.866 57.866 0 0 0-.545-.713l-.008-.044c0-.011-.027-.524-.051-.646c-.004-.049-.016-.064.036-.058c.055.046.062.049.097.065c.056.01.105-.085.072-.172l-.517-.952c-.041-.041-.095-.085-.16.011a.374.374 0 0 0-.128.283c.016.225.055.455.07.681l.022.122c-.023-.027-.051-.061-.063-.073c-.439-.462.202-.075-.084-.432c-.242-.266-.312-.349-.52-.509c-.104-.067-.167-.195-.201.023a4.553 4.553 0 0 0-.015.575c0 .092.093.26.174.36zm-8.901 1.079c.252.104.413-.376.517-.902c.07-.148.124-.164.16-.088c-.009.7.05.855.23 1.068c.401.31.733.039.76.013l.312-.312c.069-.073.162-.078.26-.013c.096.086.083.236.287.34c.172.069.54.016.625-.132c.115-.196.143-.264.195-.338c.082-.109.222-.06.222-.026c-.013.061-.095.122-.039.231c.098.073.12.026.178.01c.204-.098.356-.54.356-.54c.009-.165-.083-.151-.143-.117c-.078.047-.083.063-.161.111c-.1.015-.293.081-.388-.067c-.098-.178-.1-.426-.174-.605c0-.013-.13-.283-.009-.3c.061.011.19.045.211-.063c.063-.106-.137-.408-.273-.561c-.119-.13-.284-.146-.443-.013c-.112.103-.096.217-.118.326a.508.508 0 0 0 .105.443c.111.219.314.502.247.898c0 0-.118.188-.325.164c-.086-.019-.226-.056-.3-.606c-.056-.417.014-1-.163-1.273c-.064-.165-.11-.324-.266-.042c-.042.111-.222.279-.091.626c.107.219.15.576.102.974c-.074.113-.09.151-.187.264c-.136.146-.283.109-.396.054c-.106-.071-.188-.108-.236-.334c.009-.36.029-.95-.037-1.075c-.097-.194-.257-.124-.326-.065c-.329.301-.491.808-.59 1.211c-.091.294-.188.21-.256.091c-.166-.156-.177-1.373-.378-1.172c-.323.914.182 1.918.532 1.82z"> </path> <path d="M20.137 15.524l-.096-.055l-1.881-.009c-.097-.037-.068-.069 0-.095c.449-.061 1.248-.191 1.301-.958c-.009-.399-.172-.661-.662-.733c-.359.028-.616.377-.575.76c-.017.104.034.306-.071.329c-.691.063-1.444.495-1.469.805c-.042.029-.136-.055-.124-.187a3.694 3.694 0 0 0-.475-1.606c-.218-.218-.15-.146-.296-.043c-.094.108-.111.182-.106.397c0 .008.176.499.325.843c.099.353.192.756.125 1.137c-.232.504-.699.956-1.149 1.201c-.232.075-.431.048-.48-.004c-.143-.096-.136-.273-.125-.276c.379-.265.813-.478 1.153-1.191c.1-.272.13-.437.031-.858a.814.814 0 0 0-.197-.398c.061-.04.236.093.263.014a1.253 1.253 0 0 0-.331-.61c-.135-.123-.282-.137-.406-.024c-.14.078-.17.356-.103.6c.074.184.275.215.419.584c0 .008.052.276-.022.381c-.059.184-.824.785-.866.812c-.021.026-.012-.013-.015-.113c-.005-.122.049-.41.034-.412c-.249.161-.332.654-.377.8c-.63.435-1.343.759-1.755 1.201c-.215.335 1.478-.385 1.675-.472c.044.032.039.183.157.318c.176.238.548.385.913.294c.61-.221.963-.637 1.321-1.098c.051-.075.131-.132.205-.075c.246.551.957.941 1.874.982c.213-.259.11-.384.024-.438c0-.008-.453-.18-.522-.352c-.042-.156.06-.293.264-.397c.589-.071 1.168-.15 1.729-.33c.006-.188.115-.47.19-.592c.072-.124.111-.087.1-.132zm-1.547-1.172c.028-.047.121-.045.208.006c.087.05.136.13.107.177c-.028.048-.122.045-.209-.006c-.087-.05-.134-.129-.106-.177zm-.757 1.9c-.202.069-.396.123-.396.415c.075.406-.103.267-.208.211c-.124-.089-.473-.304-.523-.768c-.008-.111.079-.204.218-.204c.209.057.518.061.786.089c.219.014.328.186.123.257zm-6.967-4.505c.216.104.624.06.606-.29c0-.031-.008-.135-.011-.163c-.044-.103-.164-.078-.192.029c-.009.035.015.091-.016.109c-.018.018-.087.007-.084-.089c0-.031-.023-.064-.036-.083c-.014-.009-.022-.012-.047-.012c-.03.001-.03.009-.046.035c-.007.025-.017.051-.017.08c-.004.034-.017.046-.042.052c-.028 0-.022.003-.044-.012c-.014-.015-.031-.021-.031-.046a.276.276 0 0 0-.014-.086c-.012-.016-.031-.023-.053-.029c-.118 0-.126.135-.119.187c-.011.009-.015.251.146.318z"> </path> <path d="M17.512 14.027c0-.031-.023-.063-.036-.083c-.014-.009-.022-.012-.047-.012c-.03.001-.029.009-.046.035c-.007.026-.017.051-.017.08c-.003.035-.017.047-.042.052c-.028 0-.022.003-.045-.011c-.014-.015-.031-.021-.031-.046a.271.271 0 0 0-.014-.086c-.012-.016-.031-.023-.053-.028c-.118 0-.126.135-.12.186c-.009.01-.014.251.147.319c.217.103.732.043.606-.29a2.88 2.88 0 0 0-.011-.164c-.044-.103-.165-.077-.192.029c-.008.035.016.091-.016.109c-.016.018-.086.007-.083-.09zm3.397-.707c.216.104.623.06.605-.289a2.88 2.88 0 0 0-.011-.164c-.044-.103-.164-.077-.191.029c-.009.035.015.091-.017.109c-.018.018-.087.008-.084-.089c0-.031-.023-.064-.036-.083c-.014-.009-.022-.012-.048-.012c-.03.002-.029.009-.046.035c-.007.026-.017.051-.017.08c-.004.035-.017.047-.042.052c-.028 0-.022.003-.045-.011c-.014-.015-.03-.021-.03-.046a.283.283 0 0 0-.014-.087c-.013-.016-.031-.023-.054-.028c-.118 0-.126.135-.119.186c-.007.01-.012.251.149.318zm.146-1.352c.077.216-.059.422.022.452c.073.034.177-.223.215-.46c.045-.192-.092-.585-.286-.666c-.118-.028-.286.042-.232.2c-.027.076.238.334.281.474zm1.995 5.064c.151.001.325-.345.399-.688c.041-.472-.028-.759-.04-1.037c-.013-.277-.313-2.392-.375-2.602c-.073-.397.293-.053.253-.284c-.127-.291-.442-.714-.542-.967c-.06-.108-.034-.204-.168-.028c-.123.405-.166.735-.119.987c.318 1.66.644 3.04.592 4.619zm3.756-4.34c.035.108-.053.457.02.489c.067.036.161-.241.196-.498c.019-.141-.084-.633-.261-.721c-.108-.03-.261.045-.211.217c-.025.083.217.361.256.513zm-13.119 3.656c.065.027.154-.177.188-.366c.019-.104-.081-.465-.25-.53c-.104-.022-.246.006-.202.16c-.005.083.23.183.244.376c.034.08-.05.337.02.36zm-4.556-4.615c.033.083-.033.348.036.373c.063.028.152-.184.185-.379c.019-.108.004-.474-.246-.549c-.103-.023-.246.034-.199.165c-.024.062.187.274.224.39zm4.902 1.173c-.191.104-.266.412-.146.591c.111.159.287.1.311.1c.188.023.299-.352.299-.352s.006-.105-.217.094c-.094.018-.106-.017-.129-.071a.456.456 0 0 1 .029-.292c.032-.093-.04-.134-.147-.07zm1.442-1.153a.257.257 0 0 0 .118-.174c.029-.146-.155.069-.178-.094c-.041-.151.077-.213.189-.359c.004-.101.002-.172-.135-.09c-.096.065-.288.263-.294.491c-.006.129-.03.128.055.21c.061.089.122.08.245.016zm1.299.078c.124-.336.124-.478.133-.621c-.038-.217-.185-.21-.282.031c-.042.091-.091.57-.083.57c-.033.143.149.204.232.02zm8.17 2.383s-1.003.713-1.027.738c-.1.088-.05.4 0 .364c.071.028 1.08-.657 1.06-.737c.047.002.07-.401-.033-.365zm-.123 1.934c.067.036.244-.183.237-.456c.02-.141-.051-.658-.227-.746c-.108-.03-.252.062-.202.233c-.025.082.124.369.163.521c.035.109-.044.416.029.448zm-5.68 1.496c0 .009.085.082.185.024c.21-.081.342-.159.636-.224c.077-.001.072-.208-.05-.215c-.159.008-.307.016-.466.142c-.098.022-.114-.037-.136-.091c-.024-.133.055-.225.038-.324c.006.006-.091-.083-.19-.033c-.005 0-.221.146-.29.248c-.043.033-.038.061-.025.116c.033.076.092.053.158.017c.088-.012.13.046.123.151c-.042.133.017.182.017.189zm6.551.166c-.033.057-.055.143.047.17c.188.053.621-.229.621-.234c.07-.053.047-.152.041-.152c-.041-.047-.133-.02-.195-.027c-.029 0-.127-.015-.08-.101a.598.598 0 0 0 .078-.151c.029-.065.004-.108-.102-.143c-.107-.02-.15-.01-.269 0c-.064.014-.086.042-.098.12c.005.118.076.112.15.159c.043.055.071.105-.003.194c-.07.065-.119.101-.19.165zM25.5 23H24v-.5a.5.5 0 0 0-1 0v.5H11s0 1 3 1h9v.5a.5.5 0 0 0 1 0V24h1v.5a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5z"> </path> </g> </g></svg>
           */}{" "}
        </span>
        <span> French </span>
      </button>
    );
  } else {
    return (
      <button className="lang" onClick={changeLanguage("en")}>
        <span>
          <svg
            fill="#000000"
            width="64px"
            height="64px"
            viewBox="-1 0 19 19"
            xmlns="http://www.w3.org/2000/svg"
            className="cf-icon-svg"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              <path d="M16.417 9.57a7.917 7.917 0 1 1-8.144-7.908 1.758 1.758 0 0 1 .451 0 7.913 7.913 0 0 1 7.693 7.907zM5.85 15.838q.254.107.515.193a11.772 11.772 0 0 1-1.572-5.92h-3.08a6.816 6.816 0 0 0 4.137 5.727zM2.226 6.922a6.727 6.727 0 0 0-.511 2.082h3.078a11.83 11.83 0 0 1 1.55-5.89q-.249.083-.493.186a6.834 6.834 0 0 0-3.624 3.622zm8.87 2.082a14.405 14.405 0 0 0-.261-2.31 9.847 9.847 0 0 0-.713-2.26c-.447-.952-1.009-1.573-1.497-1.667a8.468 8.468 0 0 0-.253 0c-.488.094-1.05.715-1.497 1.668a9.847 9.847 0 0 0-.712 2.26 14.404 14.404 0 0 0-.261 2.309zm-.974 5.676a9.844 9.844 0 0 0 .713-2.26 14.413 14.413 0 0 0 .26-2.309H5.903a14.412 14.412 0 0 0 .261 2.31 9.844 9.844 0 0 0 .712 2.259c.487 1.036 1.109 1.68 1.624 1.68s1.137-.644 1.623-1.68zm4.652-2.462a6.737 6.737 0 0 0 .513-2.107h-3.082a11.77 11.77 0 0 1-1.572 5.922q.261-.086.517-.194a6.834 6.834 0 0 0 3.624-3.621zM11.15 3.3a6.82 6.82 0 0 0-.496-.187 11.828 11.828 0 0 1 1.55 5.89h3.081A6.815 6.815 0 0 0 11.15 3.3z"></path>
            </g>
          </svg>
          {/*             <svg viewBox="0 -4 28 28" fill="none" ><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <g clipPath="url(#clip0_503_3486)"> <rect width="28" height="20" rx="2" fill="white"></rect> <mask id="mask0_503_3486" maskUnits="userSpaceOnUse" x="0" y="0" width="28" height="20"> <rect width="28" height="20" rx="2" fill="white"></rect> </mask> <g mask="url(#mask0_503_3486)"> <path fillRule="evenodd" clipRule="evenodd" d="M28 0H0V1.33333H28V0ZM28 2.66667H0V4H28V2.66667ZM0 5.33333H28V6.66667H0V5.33333ZM28 8H0V9.33333H28V8ZM0 10.6667H28V12H0V10.6667ZM28 13.3333H0V14.6667H28V13.3333ZM0 16H28V17.3333H0V16ZM28 18.6667H0V20H28V18.6667Z" fill="#D02F44"></path> <rect width="12" height="9.33333" fill="#46467F"></rect> <g filter="url(#filter0_d_503_3486)"> <path fillRule="evenodd" clipRule="evenodd" d="M2.66665 1.99999C2.66665 2.36818 2.36817 2.66666 1.99998 2.66666C1.63179 2.66666 1.33331 2.36818 1.33331 1.99999C1.33331 1.63181 1.63179 1.33333 1.99998 1.33333C2.36817 1.33333 2.66665 1.63181 2.66665 1.99999ZM5.33331 1.99999C5.33331 2.36818 5.03484 2.66666 4.66665 2.66666C4.29846 2.66666 3.99998 2.36818 3.99998 1.99999C3.99998 1.63181 4.29846 1.33333 4.66665 1.33333C5.03484 1.33333 5.33331 1.63181 5.33331 1.99999ZM7.33331 2.66666C7.7015 2.66666 7.99998 2.36818 7.99998 1.99999C7.99998 1.63181 7.7015 1.33333 7.33331 1.33333C6.96512 1.33333 6.66665 1.63181 6.66665 1.99999C6.66665 2.36818 6.96512 2.66666 7.33331 2.66666ZM10.6666 1.99999C10.6666 2.36818 10.3682 2.66666 9.99998 2.66666C9.63179 2.66666 9.33331 2.36818 9.33331 1.99999C9.33331 1.63181 9.63179 1.33333 9.99998 1.33333C10.3682 1.33333 10.6666 1.63181 10.6666 1.99999ZM3.33331 3.99999C3.7015 3.99999 3.99998 3.70152 3.99998 3.33333C3.99998 2.96514 3.7015 2.66666 3.33331 2.66666C2.96512 2.66666 2.66665 2.96514 2.66665 3.33333C2.66665 3.70152 2.96512 3.99999 3.33331 3.99999ZM6.66665 3.33333C6.66665 3.70152 6.36817 3.99999 5.99998 3.99999C5.63179 3.99999 5.33331 3.70152 5.33331 3.33333C5.33331 2.96514 5.63179 2.66666 5.99998 2.66666C6.36817 2.66666 6.66665 2.96514 6.66665 3.33333ZM8.66665 3.99999C9.03484 3.99999 9.33331 3.70152 9.33331 3.33333C9.33331 2.96514 9.03484 2.66666 8.66665 2.66666C8.29846 2.66666 7.99998 2.96514 7.99998 3.33333C7.99998 3.70152 8.29846 3.99999 8.66665 3.99999ZM10.6666 4.66666C10.6666 5.03485 10.3682 5.33333 9.99998 5.33333C9.63179 5.33333 9.33331 5.03485 9.33331 4.66666C9.33331 4.29847 9.63179 3.99999 9.99998 3.99999C10.3682 3.99999 10.6666 4.29847 10.6666 4.66666ZM7.33331 5.33333C7.7015 5.33333 7.99998 5.03485 7.99998 4.66666C7.99998 4.29847 7.7015 3.99999 7.33331 3.99999C6.96512 3.99999 6.66665 4.29847 6.66665 4.66666C6.66665 5.03485 6.96512 5.33333 7.33331 5.33333ZM5.33331 4.66666C5.33331 5.03485 5.03484 5.33333 4.66665 5.33333C4.29846 5.33333 3.99998 5.03485 3.99998 4.66666C3.99998 4.29847 4.29846 3.99999 4.66665 3.99999C5.03484 3.99999 5.33331 4.29847 5.33331 4.66666ZM1.99998 5.33333C2.36817 5.33333 2.66665 5.03485 2.66665 4.66666C2.66665 4.29847 2.36817 3.99999 1.99998 3.99999C1.63179 3.99999 1.33331 4.29847 1.33331 4.66666C1.33331 5.03485 1.63179 5.33333 1.99998 5.33333ZM3.99998 5.99999C3.99998 6.36819 3.7015 6.66666 3.33331 6.66666C2.96512 6.66666 2.66665 6.36819 2.66665 5.99999C2.66665 5.6318 2.96512 5.33333 3.33331 5.33333C3.7015 5.33333 3.99998 5.6318 3.99998 5.99999ZM5.99998 6.66666C6.36817 6.66666 6.66665 6.36819 6.66665 5.99999C6.66665 5.6318 6.36817 5.33333 5.99998 5.33333C5.63179 5.33333 5.33331 5.6318 5.33331 5.99999C5.33331 6.36819 5.63179 6.66666 5.99998 6.66666ZM9.33331 5.99999C9.33331 6.36819 9.03484 6.66666 8.66665 6.66666C8.29846 6.66666 7.99998 6.36819 7.99998 5.99999C7.99998 5.6318 8.29846 5.33333 8.66665 5.33333C9.03484 5.33333 9.33331 5.6318 9.33331 5.99999ZM9.99998 8C10.3682 8 10.6666 7.70152 10.6666 7.33333C10.6666 6.96514 10.3682 6.66666 9.99998 6.66666C9.63179 6.66666 9.33331 6.96514 9.33331 7.33333C9.33331 7.70152 9.63179 8 9.99998 8ZM7.99998 7.33333C7.99998 7.70152 7.7015 8 7.33331 8C6.96512 8 6.66665 7.70152 6.66665 7.33333C6.66665 6.96514 6.96512 6.66666 7.33331 6.66666C7.7015 6.66666 7.99998 6.96514 7.99998 7.33333ZM4.66665 8C5.03484 8 5.33331 7.70152 5.33331 7.33333C5.33331 6.96514 5.03484 6.66666 4.66665 6.66666C4.29846 6.66666 3.99998 6.96514 3.99998 7.33333C3.99998 7.70152 4.29846 8 4.66665 8ZM2.66665 7.33333C2.66665 7.70152 2.36817 8 1.99998 8C1.63179 8 1.33331 7.70152 1.33331 7.33333C1.33331 6.96514 1.63179 6.66666 1.99998 6.66666C2.36817 6.66666 2.66665 6.96514 2.66665 7.33333Z" fill="url(#paint0_linear_503_3486)"></path> </g> </g> </g> <defs> <filter id="filter0_d_503_3486" x="1.33331" y="1.33333" width="9.33331" height="7.66667" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB"> <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood> <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix> <feOffset dy="1"></feOffset> <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"></feColorMatrix> <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_503_3486"></feBlend> <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_503_3486" result="shape"></feBlend> </filter> <linearGradient id="paint0_linear_503_3486" x1="1.33331" y1="1.33333" x2="1.33331" y2="7.99999" gradientUnits="userSpaceOnUse"> <stop stopColor="white"></stop> <stop offset="1" stopColor="#F0F0F0"></stop> </linearGradient> <clipPath id="clip0_503_3486"> <rect width="28" height="20" rx="2" fill="white"></rect> </clipPath> </defs> </g></svg>
           */}{" "}
        </span>
        <span> English </span>
      </button>
    );
  }
};

const checkTxnStatus = (status: string) => {
  switch (status) {
    case "success":
      return "success";
    case "settled":
      return "success";
    case "fail":
      return "failed";
    case "decline":
      return "failed";
    case "refund":
      return "pending";
    case "3ds":
      return "pending";
    case "redirect":
      return "pending";
  }
};

const getIntialsImageShow = (merchantName: string) => {
  let initials = "";

  const nameWords = merchantName?.split(" ");

  if (nameWords?.length === 1) {
    initials = nameWords[0]?.substring(0, 2).toUpperCase();
  } else if (nameWords?.length >= 2) {
    initials = nameWords.map((word) => word[0]?.toUpperCase()).join("");
  }
  return initials;
};

const fileToBase64 = (
  file: Blob,
  cb: {
    (err: any, result: any): void;
    (
      arg0: ProgressEvent<FileReader> | null,
      arg1: string | ArrayBuffer | null
    ): void;
  }
) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = function () {
    cb(null, reader.result);
  };
  reader.onerror = function (error) {
    cb(error, null);
  };
};

// Function to convert hex code to RGB
function hexToRgb(hex: string, opacity?: number): string {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (result) {
    const r = parseInt(result[1], 16);
    const g = parseInt(result[2], 16);
    const b = parseInt(result[3], 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }

  return "";
}

// Function to convert RGB to hex code
function rgbToHex(rgb: string): string | null {
  const result = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
  if (result) {
    const r = parseInt(result[1], 10);
    const g = parseInt(result[2], 10);
    const b = parseInt(result[3], 10);
    return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
  }
  return null;
}

const detectBase64ImageType = (image: string) => {
  if (image) {
    var decodedImage = window?.atob(image).slice(0, 12).toLocaleLowerCase();
    if (decodedImage.includes("gif")) {
      return `data:image/gif;base64,${image}`;
    } else if (decodedImage.includes("svg")) {
      return `data:image/svg+xml;base64,${image}`;
    } else if (decodedImage.includes("png")) {
      return `data:image/png;base64,${image}`;
    } else {
      return `data:image/jpeg;base64,${image}`;
    }
  }
};

const handleSoftposTransactionType = (
  Type: any,
  trxType: any[],
  trxStatus: any[],
  recStatus: any[]
) => {
  switch (Type) {
    case "1":
      return <span className="greenBg"> {trxType[0]}</span>;
      break;
    case "2":
      return <span className="yellowBg">{trxType[1]}</span>;
      break;
    case "3":
      return <span className="redBg">{trxType[2]} </span>;
      break;
    case "Success":
      return <span className="greenBg">{trxStatus[0]}</span>;
      break;
    case "Pending":
      return <span className="yellowBg">{trxStatus[1]}</span>;
      break;
    case "Failed":
      return <span className="redBg">{trxStatus[2]}</span>;
      break;
    case "Not_Settled":
      return <span className="yellowBg">{recStatus[0]}</span>;
      break;
    case "Settled":
      return <span className="greenBg">{recStatus[1]}</span>;
      break;
  }
};

const setBrowserTabImageAndLogo = (logo: string, name: string) => {
  document.title = `${name}  `;
  // add the new favicon
  if (logo) {
    var link: any = document.createElement("link");
    link.rel = "shortcut icon";
    link.type = "image/png";
    link.href = detectBase64ImageType(logo);
    // remove any existing favicon
    var existingLink = document.querySelector('link[rel="icon"]');
    if (existingLink) {
      document.head.removeChild(existingLink);
    }
    document.head.appendChild(link);
  }
};

function formatDateYYYYMMDD(date: Date): string {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-indexed
  const day = date.getDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
}

function getRandomInt(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

const getHomePage = (projects: any, accountId?: string) => {
  if (!projects?.softPos && projects?.paymentGateway) {
    return {
      adminHomepage: `/admin/PaymentGatewayDashboard`,
      partnerHomePage: `/partner/PaymentGatewayDashboard/${accountId}`,
      mercahntHomePage: `/merchant/${accountId}/paymentGateway/Dashboard`,
    };
  } else {
    return {
      adminHomepage: `/admin/SoftposDashboard`,
      partnerHomePage: `/partner/SoftposDashboard/${accountId}`,
      mercahntHomePage: `/merchant/${accountId}`,
    };
  }
};

const handleFormateCurrency = (amount: any = 0, ...rest: any[]) => {
  const [currency, lang, currencySign, style]: any = rest;
  const minimumFractionDigits = currency === "TND" ? 3 : 2;
  const encodeCurr = handleLangugeDirection(lang, "currencyLang");
  const FormatedAmount = Intl.NumberFormat(encodeCurr, {
    style: style || "currency",
    currency: currency ?? "TND",
    minimumFractionDigits,
    currencySign:
      currencySign ||
      "accounting" /* currencyDisplay: currencyDisplay ||"name" */,
  });
  return FormatedAmount.format(amount).toString();
};

const handleSetLogoAndTitle = (logo: string) => {
  // add the new favicon
  var link: any = document.createElement("link");
  link.rel = "shortcut icon";
  link.type = "image/png";
  link.href = detectBase64ImageType(logo); //`data:image/svg;base64,${logo}`;
  // remove any existing favicon
  var existingLink = document.querySelector('link[rel="icon"]');
  if (existingLink) {
    document.head.removeChild(existingLink);
  }
  document.head.appendChild(link);
};

const handleLangugeDirection = (
  lang: string,
  type: string,
  HandlingFunc?: ((...params: any) => void | any) | any,
  themes?: any
): any => {
  const existingLang = {
    ltr: { direction: "ltr", languages: ["en", "fr"] },
    rtl: { direction: "rtl", languages: ["ar", "tn"] },
  };

  if (existingLang.rtl.languages.includes(lang)) {
    switch (type) {
      case "divDirection":
        HandlingFunc(existingLang.rtl.direction);
        break;
      case "currPartner":
        HandlingFunc(themes?.currencyAr1, themes?.nameAR);
        break;
      case "layoutRight":
        return "0px";
        break;
      case "contextMenuDistance":
        return HandlingFunc(0);
        break;
      case "customInput":
        HandlingFunc("right", "left");
        break;
      case "dropdown__notifStyle":
        return { left: "0px" };
        break;
      case "dropdown__window":
        return { left: "0px" };
        break;
      case "expandCollapse":
        return HandlingFunc(false);
        break;
      case "locale":
        return themes.arSA;
        break;
      case "marginChange":
        HandlingFunc("marginRight", "right");
        break;
      case "Arrow":
        return HandlingFunc(existingLang.rtl.direction);
        break;
      case "backgroundPosition":
        return "left";
        break;
      case "currency":
        return { currency1: themes.currencyAr1, currency2: themes.currencyAr2 };
        break;
      case "date-picker":
        return { right: "-200px" };
        break;
      case "EnArPortalName":
        return themes.nameAR;
        break;
      case "ArEnCardStyle":
        return "ar-card";
        break;
      case "currencyLang":
        return "ar-SA";
        break;
    }
  } else {
    switch (type) {
      case "divDirection":
        HandlingFunc(existingLang.ltr.direction);
        break;
      case "currPartner":
        HandlingFunc(themes?.currencyEn1, themes?.name);
        break;
      case "layoutRight":
        return "unset";
        break;
      case "contextMenuDistance":
        return HandlingFunc(150);
        break;
      case "customInput":
        HandlingFunc("left", "right");
        break;
      case "dropdown__notifStyle":
        return { right: "0px" };
        break;
      case "dropdown__window":
        return { right: "0px" };
        break;
      case "expandCollapse":
        return HandlingFunc(true);
        break;
      case "locale":
        return themes.enUS;
        break;
      case "marginChange":
        HandlingFunc("marginLeft", "left");
        break;
      case "Arrow":
        return HandlingFunc(existingLang.ltr.direction);
        break;
      case "backgroundPosition":
        return "right";
        break;
      case "currency":
        return { currency1: themes.currencyEn1, currency2: themes.currencyEn2 };
      case "date-picker":
        return { left: themes?.value };
        break;
      case "EnArPortalName":
        return themes.name;
        break;
      case "ArEnCardStyle":
        return "en-card";
        break;
      case "currencyLang":
        return "en-US";
        break;
    }
  }
};

export {
  isPasswordValid,
  capitalizeFirstLetter,
  getImageForPaymentMethod,
  trimString,
  isValidDateFormat,
  formatDate,
  formatDateAndTime,
  separateDateAndTime,
  languageChoose,
  checkTxnStatus,
  getIntialsImageShow,
  fileToBase64,
  rgbToHex,
  hexToRgb,
  detectBase64ImageType,
  setBrowserTabImageAndLogo,
  addSpacesToCamelCase,
  handleSoftposTransactionType,
  formatDateYYYYMMDD,
  getRandomInt,
  getHomePage,
  handleFormateCurrency,
  handleSetLogoAndTitle,
  handleLangugeDirection,
};
